import {
  FORGET_PASSWORD,
  FORGET_PASSWORD_SUCCESS,
  FORGET_PASSWORD_ERROR,
  FORGET_PASSWORD_RESET,
} from "./actionTypes";

export const forgetPassword = (user) => {
  return {
    type: FORGET_PASSWORD,
    payload: { user },
  };
};

export const forgetPasswordSuccess = () => {
  return {
    type: FORGET_PASSWORD_SUCCESS,
  };
};

export const forgetPasswordError = (error) => {
  return {
    type: FORGET_PASSWORD_ERROR,
    payload: error,
  };
};

export const forgetPasswordReset = () => {
  return {
    type: FORGET_PASSWORD_RESET,
  };
};
